module.exports = __webpack_public_path__ + "static/media/form4.5ec12780.png";